/**
 * Bridge between Dawn's <predictive-search> shell and Nosto's autocomplete.
 *
 * Approach B: keep Dawn's custom element so the open/close UX, focus
 * trapping, escape-to-close behaviour and modal blur overlay all keep
 * working. We just stop Dawn from fetching `/search/suggest` so the
 * native panel never populates — the Preact `AutocompleteInjected`
 * component owns the dropdown content via portal into
 * `[data-nosto-autocomplete-dropdown]`.
 *
 * Loaded only when `settings.nosto_enabled === true`.
 */
(function () {
	if (typeof customElements === 'undefined') return;

	customElements
		.whenDefined('predictive-search')
		.then(function () {
			var PredictiveSearch = customElements.get('predictive-search');
			if (!PredictiveSearch || !PredictiveSearch.prototype) return;

			// Neutralise Dawn's fetch & DOM manipulation. Each is wrapped in a
			// guard so we don't break Dawn if any signature changes upstream.
			['getSearchResults', 'renderSearchResults', 'open', 'close']
				.filter(function (fn) {
					return typeof PredictiveSearch.prototype[fn] === 'function';
				})
				.forEach(function (fn) {
					var original = PredictiveSearch.prototype[fn];
					PredictiveSearch.prototype[fn] = function () {
						// Open/close still need to run so the modal blur, status
						// dispatch, and aria attributes stay correct. The fetch
						// pair is swallowed entirely.
						if (fn === 'open' || fn === 'close') {
							return original.apply(this, arguments);
						}
						// Hide Dawn's data-predictive-search panel — Nosto owns
						// the dropdown now.
						var nativePanel = this.querySelector('[data-predictive-search]');
						if (nativePanel) nativePanel.style.display = 'none';
					};
				});
		})
		.catch(function () {
			// `whenDefined` rejects if the element name is invalid — never
			// happens here, but swallow defensively.
		});
})();
